import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Row, Select, Button, Alert } from 'antd';
import {
  usePaymentArrangement,
  useRequestDropDown,
  useIdType,
  useRequestValidate,
  useBankCode,
  useGetOptionAndPaymentPdf,
} from 'all-in-one-shared-api';
import { Spinner } from 'components';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
// import { Attachments } from 'types';
import styled from 'styled-components';
import GreetingSection from 'components/navbar/GreetingSection';
import './Changepastyle.less';
import { PaymentInfomationCard } from './components/PaymenttactCard';
import { PaymenttactCardno } from './components/PaymenttactCardno';
import { ChangePaymentContactCard } from './components/ChangePaymentContactCard';
import edit from 'assets/images/MakeRequest/edit.svg';
import editdisabled from 'assets/images/MakeRequest/editdisabled.svg';
import { PaymentArrangementFormData } from './utile/PaymentArrangementFormData';
import generateKey from 'utils/generateKey';
import { AgreementCard2 } from './components/Agreement/AgreementCard2';
import { PaymentConfrimCard } from './components/PaymentConfrimCard';
import { useNavigate, useLocation } from 'react-router-dom';
import { isLocaleEnglish } from 'utils/languageUtils';
// import { useNavigate } from 'react-router-dom';
import { revalidateAntdFormLanguageChanged } from '../../i18n';

//内容部分布局
const EnquiryPageContainer = styled.div`
  margin: 0;
`;
interface LocationState {
  policyNo?: string;
}
//页面
function ChangePaymentArrangement() {
  //定义变量
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const navigate = useNavigate();
  const [form] = Form.useForm<PaymentArrangementFormData>();
  const [form2] = Form.useForm<PaymentArrangementFormData>();
  // const methods = useForm();
  const [isAgreed, setIsAgreed] = useState(false);
  const [key, setKey] = useState<string>('cahduashdiagdia');
  const [companyCode, setCompanyCode] = useState('2');
  const [policyNumber, setPolicyNumber] = useState<string>('');
  const [startLoading, setStartLoading] = useState<boolean>(false);
  const [EditCode, setEditCode] = useState<boolean>(false);
  const [EditDisable, setEditDisable] = useState<boolean>(false);
  const [showInactive, setShowInactive] = useState<boolean>(false);
  const [aftersub, setaftersub] = useState<boolean>(false);
  const [Errmessage, setErrmessage] = useState<string>('Errmessage');
  const [bankdefult, setbankdefult] = useState('');
  const [randoms, setRandoms] = useState(Math.random());

  // const [requestData, setrequestData] = useState<ContactFormData>();
  // const navigate = useNavigate();
  const childRef =
    useRef<{ getOriginValue: () => string; getCardOriginValue: () => string; getIdOriginValue: () => string }>(null);

  const location = useLocation();
  const { policyNo } = (location.state as LocationState) ?? {};
  const { token } = useKeycloakReady();
  const {
    shouldFetch: shouldFecthResquestDrop,
    data: RequestdropData,
    error: requestError,
  } = useRequestDropDown('useRequestDropDown', token || '');
  const {
    shouldFetch: shouldFecthDrop,
    data: dropData,
    // isLoading: dropDataisLoading,
  } = useRequestDropDown('useRequestDropDown', token || '');
  const { data: idType, shouldFetch: shouldFetchIdType } = useIdType(token || '');

  const policyTypesObject: { label: string; label2: string; value: string; inactiveAutoPayAccount?: string }[] = [];
  useEffect(() => {
    shouldFecthDrop(true);
    shouldFetchIdType(true);
  }, [shouldFecthDrop, shouldFetchIdType]);
  useEffect(() => {
    if (requestError?.code && requestError?.message) {
      navigate('/ChangeRequestErrorpage', {
        replace: true,
      });
    }
  }, [requestError, shouldFecthResquestDrop, navigate]);
  dropData?.map((item) => {
    policyTypesObject.push({
      label: i18n.language == 'en' ? item.productName : item.productNameTC,
      label2: `${t('life.enquiry.policyNo')}${item.policyNumber}`,
      value: item.policyNumber,
      inactiveAutoPayAccount: item.inactiveAutoPayAccount,
      // isRead: item.isRead,
    });
  });

  const {
    data: ArrangeInformation,
    shouldFetch: ContactInformationShouldFetch,
    error: ArrangeInfoError,
  } = usePaymentArrangement(key, token || '', policyNumber, companyCode);
  useEffect(() => {
    if (policyNumber) {
      ContactInformationShouldFetch(true);
      setStartLoading(true);
    }
    if (policyNo && policyNumber == '') {
      const code = RequestdropData?.find((item) => item.policyNumber == policyNo)?.companyCode;
      if (code) {
        setKey(generateKey());
        setCompanyCode(code);
        setPolicyNumber(policyNo);
        setStartLoading(true);
        ContactInformationShouldFetch(true);
      }
    }
  }, [ContactInformationShouldFetch, setStartLoading, policyNumber, policyNo, RequestdropData]);
  useEffect(() => {
    setKey(generateKey());
    setCompanyCode('2');
    shouldFecthResquestDrop(true);
    // ContactInformationShouldFetch(true);
  }, [shouldFecthResquestDrop]);
  useEffect(() => {
    if (ArrangeInformation && !ArrangeInfoError) {
      if (ArrangeInformation?.changeStatusCode !== 'None' && ArrangeInformation?.changeStatusCode !== '') {
        setEditDisable(true);
        if (i18n.language == 'en') {
          setErrmessage(ArrangeInformation?.changeStatusDesc);
        } else {
          setErrmessage(ArrangeInformation?.changeStatusDescTc);
        }
        setShowInactive(false);
      } else {
        setErrmessage('');
        if (ArrangeInformation?.salesUnitCode == 'ZAL') {
          setEditDisable(true);
        } else {
          setEditDisable(false);
        }
        if (ArrangeInformation?.inactiveAutoPayAccount == 'Y') {
          setShowInactive(true);
        } else {
          setShowInactive(false);
        }
      }
      setStartLoading(false);
    }

    if (ArrangeInfoError) {
      setStartLoading(false);
    }
  }, [ArrangeInformation, ArrangeInfoError, form, i18n.language]);
  useEffect(() => {
    if (ArrangeInformation && !ArrangeInfoError) {
      form.setFieldsValue({
        bankAccountNumber: ArrangeInformation?.bankAccount,
        CreditCard: ArrangeInformation?.cardNo,
        passport: ArrangeInformation?.idNumber,
        passportOrigin: ArrangeInformation?.idNumber,
        bankAccountNumberOrigin: ArrangeInformation?.bankAccount,
        CreditCardOrigin: ArrangeInformation?.cardNo,
        bankCode: ArrangeInformation?.branchCode == '' ? null : ArrangeInformation?.branchCode,
        accountHolder: `${ArrangeInformation?.holderSureName} ${ArrangeInformation?.holderFirstName}`,
        IDtype: idType?.find((item) => item.idType == ArrangeInformation?.idType)?.idTypeDesc,
        branchNumber: ArrangeInformation?.branchNumber,
        paymentMode: ArrangeInformation?.paymentModeDesc,
        paymentModeTc: ArrangeInformation?.paymentModeDescTc,
        paymentMethoddf: ArrangeInformation?.paymentMethod,
        paymentModedf: ArrangeInformation?.paymentMode,
        RenewalPaymentMethod: ArrangeInformation?.paymentMethodDesc,
        RenewalPaymentMethodTc: ArrangeInformation?.paymentMethodDescTc,

        AutopayStatus: ArrangeInformation?.mandateStatusDesc,
        AutopayStatusTc: ArrangeInformation?.mandateStatusDescTc,
        expiryDate: ArrangeInformation?.creditCardExpiryDate,
        accountHolderOrigin: `${ArrangeInformation?.holderSureName} ${ArrangeInformation?.holderFirstName}`,

        IDtypeOrigin: ArrangeInformation?.idType,

        branchNumberOrigin: ArrangeInformation?.branchNumber,
        bankCodeOrigin: ArrangeInformation?.branchCode,
        paymentModeOrigin: ArrangeInformation?.paymentModeDesc,
        RenewalPaymentMethodOrigin: ArrangeInformation?.paymentMethodDesc,
        AutopayStatusOrigin: ArrangeInformation?.mandateStatusDesc,
        expiryDateOrigin: ArrangeInformation?.creditCardExpiryDate,
        paymentMethodFlag: ArrangeInformation?.paymentMethodFlag,
        paymentModeFlag: ArrangeInformation?.paymentModeFlag,
        holderNameFlag: ArrangeInformation?.holderNameFlag,
        cardNoFlag: ArrangeInformation?.cardNoFlag,
        creditCardExpiryDateFlag: ArrangeInformation?.creditCardExpiryDateFlag,
        branchCodeFlag: ArrangeInformation?.branchCodeFlag,
        branchNumberFlag: ArrangeInformation?.branchNumberFlag,
        bankAccountFlag: ArrangeInformation?.bankAccountFlag,
        idTypeFlag: ArrangeInformation?.idTypeFlag,
        idNumberFlag: ArrangeInformation?.idNumberFlag,
      });
      setStartLoading(false);
    }
  }, [ArrangeInformation, ArrangeInfoError, form, idType]);
  useEffect(() => {
    if (idType && ArrangeInformation?.idType) {
      form.setFieldsValue({
        IDtype: idType.find((item) => item.idType == ArrangeInformation?.idType)?.idTypeDesc,
        IDtypeOrigin: idType.find((item) => item.idType == ArrangeInformation?.idType)?.idTypeDesc,
      });
    }
  }, [idType, ArrangeInformation?.idType, form]);
  const { data: bankList, shouldFetch: shouldFetchBankList } = useBankCode(token || '');
  const { shouldFetch, data: downUrl } = useGetOptionAndPaymentPdf('useGetOptionAndPaymentPdf', token || '');
  useEffect(() => {
    shouldFetchBankList(true);
    shouldFetch(true);
  }, [shouldFetchBankList, shouldFetch]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const myBankList: { label: string; value: string; labelEn: string }[] = [];
  bankList?.banks?.map((item: { bankCode: string; bankName: string; bankNameTc: string }) => {
    myBankList.push({
      label: `${item.bankCode}-${isEnglish ? item.bankName : item.bankNameTc}`,
      value: item.bankCode,
      labelEn: `${item.bankCode}-${item.bankName}`,
    });
  });
  const PnChange = (e: string) => {
    setPolicyNumber(e);
    setErrorMessage('');
    if (EditCode) {
      setaftersub(false);
      setEditCode(false);
      setKey(generateKey());
      setStartLoading(true);
      const code = RequestdropData?.find((item) => item.policyNumber == e)?.companyCode;
      if (code) {
        setCompanyCode(code);
      }
    } else {
      setKey(generateKey());
      setPolicyNumber(e);
      setStartLoading(true);
      const code = RequestdropData?.find((item) => item.policyNumber == e)?.companyCode;
      if (code) {
        setCompanyCode(code);
      }
    }
  };
  const Edit = () => {
    setEditCode(true);
  };
  const onSubmit = (values: PaymentArrangementFormData) => {
    const a = [];
    console.log('values', values);
    if (childRef.current) {
      form.setFieldsValue({ passport: childRef.current.getIdOriginValue() });
    }
    if (values.CreditCard)
      form.setFieldsValue({
        CreditCard: values.CreditCard.match(/.{1,4}/g)?.join(' '),
      });
    if (form.getFieldValue('paymentModedf') != ArrangeInformation?.paymentMode) {
      form2.setFieldsValue({
        paymentModedf: form.getFieldValue('paymentModedf'),
      });
      form2.setFieldsValue({
        paymentMode: form.getFieldValue('paymentMode'),
        paymentModeTc: form.getFieldValue('paymentModeTc'),
      });
      a.push({
        paymentModedf: `${values.paymentModedf}`,
      });
    }
    if (form.getFieldValue('paymentMethoddf') != ArrangeInformation?.paymentMethod) {
      form2.setFieldsValue({
        paymentMethoddf: form.getFieldValue('paymentMethoddf'),
      });
      form2.setFieldsValue({
        RenewalPaymentMethoden: form.getFieldValue('RenewalPaymentMethoden'),
      });
      form2.setFieldsValue({
        RenewalPaymentMethodtc: form.getFieldValue('RenewalPaymentMethodtc'),
      });
      form2.setFieldsValue({
        RenewalPaymentMethod: form.getFieldValue('RenewalPaymentMethod'),
      });

      a.push({
        paymentMethoddf: `${values.paymentMethoddf}`,
      });
    }
    if (form.getFieldValue('paymentMethoddf') == 'V') {
      if (
        (values.accountHolder != `${ArrangeInformation?.holderSureName} ${ArrangeInformation?.holderFirstName}` &&
          form.getFieldValue('paymentMethoddf') == 'V') ||
        values.CreditCard != ArrangeInformation?.cardNo ||
        form.getFieldValue('expiryDate') != ArrangeInformation?.creditCardExpiryDate
      ) {
        form2.setFieldsValue({
          accountHolder: `${values.accountHolder}`,
        });
        form2.setFieldsValue({
          CreditCard: `${form.getFieldValue('CreditCard')}`,
        });
        form2.setFieldsValue({
          expiryDate: form.getFieldValue('expiryDate'),
        });
        a.push({
          expiryDate: `${values.expiryDate}`,
        });
        a.push({
          CreditCard: `${values.CreditCard}`,
        });
        a.push({
          accountHolder: `${values.accountHolder}`,
        });
      }
    } else if (form.getFieldValue('paymentMethoddf') == 'D') {
      if (
        values.bankCode != ArrangeInformation?.branchCode ||
        values.branchNumber != ArrangeInformation?.branchNumber ||
        values.bankAccountNumber != ArrangeInformation?.bankAccount ||
        (values.accountHolder != `${ArrangeInformation?.holderSureName} ${ArrangeInformation?.holderFirstName}` &&
          form.getFieldValue('paymentMethoddf') == 'D') ||
        values.IDtype != form.getFieldValue('IDtypeOrigin') ||
        values.passport != ArrangeInformation?.idNumber
      ) {
        form2.setFieldsValue({
          bankCode: `${values.bankCode}`,
        });
        const bankname = myBankList?.find((item) => item.value === form.getFieldValue('bankCode'))?.labelEn;
        if (bankname) {
          setbankdefult(bankname);
        }
        form2.setFieldsValue({
          branchNumber: `${values.branchNumber}`,
        });
        form2.setFieldsValue({
          bankAccountNumber: `${form.getFieldValue('bankAccountNumber')}`,
        });
        form2.setFieldsValue({
          accountHolder: `${values.accountHolder}`,
        });
        form2.setFieldsValue({
          IDtype: `${values.IDtype}`,
        });
        form2.setFieldsValue({
          passport: `${form.getFieldValue('passport')}`,
        });
        a.push({
          bankCode: `${values.bankCode}`,
        });
        a.push({
          bankCode: `${values.bankCode}`,
        });
        a.push({
          bankCode: `${values.bankCode}`,
        });
        a.push({
          bankCode: `${values.bankCode}`,
        });
      }
    }
    console.log('AAAAAAAA', a);
    setRandoms(Math.random());
    shouldValidateFetch(true);
  };
  // ConfrimClick====================================================
  const isChangeList = () => {
    const changeList = [];
    // Direct Debit by Credit Card
    //Direct Debit by Bank Account
    console.log('paymentModeEn', form.getFieldValue('paymentModeEn'));
    form2.getFieldValue('paymentModedf') &&
      form2.getFieldValue('paymentModedf') != ArrangeInformation?.paymentMode &&
      changeList.push({
        key: 'paymentMode',
        changedValue: [form.getFieldValue('paymentModeEn')],
        originalValue: [ArrangeInformation?.paymentModeDesc || ''],
      });
    form2.getFieldValue('paymentMethoddf') &&
      form2.getFieldValue('paymentMethoddf') != ArrangeInformation?.paymentMethod &&
      changeList.push({
        key: 'renewalPaymentMethod',
        changedValue: [form.getFieldValue('RenewalPaymentMethoden')],
        originalValue: [ArrangeInformation?.paymentMethodDesc || ''],
      });
    if (form.getFieldValue('paymentMethoddf') == 'V') {
      form2.getFieldValue('accountHolder') &&
        changeList.push({
          key: 'creditCardAccountHolderName',
          changedValue: [form2.getFieldValue('accountHolder')],
          originalValue: [`${ArrangeInformation?.holderSureName} ${ArrangeInformation?.holderFirstName}`],
        });
      form2.getFieldValue('CreditCard') &&
        changeList.push({
          key: 'creditCardNumber',
          changedValue: [form2.getFieldValue('CreditCard')],
          originalValue: [ArrangeInformation?.cardNo || ''],
        });
      form2.getFieldValue('expiryDate') &&
        changeList.push({
          key: 'creditCardExpiryDate',
          changedValue: [form2.getFieldValue('expiryDate')],
          originalValue: [ArrangeInformation?.creditCardExpiryDate || ''],
        });
    } else if (form.getFieldValue('paymentMethoddf') == 'D') {
      form2.getFieldValue('bankCode') &&
        changeList.push({
          key: 'bankCode',
          changedValue: [bankdefult],
          originalValue: [ArrangeInformation?.branchCode || ''],
        });
      // form2.getFieldValue('AutopayStatus') &&
      //   form2.getFieldValue('AutopayStatus') != ArrangeInformation?.mandateStatusDesc &&
      //   changeList.push({
      //     key: 'mandateStatusDesc',
      //     changedValue: [form2.getFieldValue('AutopayStatus')],
      //     originalValue: [ArrangeInformation?.mandateStatusDesc || ''],
      //   });
      form2.getFieldValue('branchNumber') &&
        changeList.push({
          key: 'branchNumber',
          changedValue: [form2.getFieldValue('branchNumber')],
          originalValue: [ArrangeInformation?.mandateStatusDesc || ''],
        });
      form2.getFieldValue('bankAccountNumber') &&
        changeList.push({
          key: 'bankAccountNumber',
          changedValue: [form2.getFieldValue('bankAccountNumber')],
          originalValue: [ArrangeInformation?.mandateStatusDesc || ''],
        });
      form2.getFieldValue('accountHolder') &&
        changeList.push({
          key: 'accountHolderName',
          changedValue: [form2.getFieldValue('accountHolder')],
          originalValue: [ArrangeInformation?.holderFirstName || ''],
        });
      form2.getFieldValue('IDtype') &&
        changeList.push({
          key: 'idType',
          changedValue: [form2.getFieldValue('IDtype')],
          originalValue: [form.getFieldValue('IDtypeOrigin') || ''],
        });
      form2.getFieldValue('passport') &&
        changeList.push({
          key: 'idCardPassport',
          changedValue: [form2.getFieldValue('passport')],
          originalValue: [ArrangeInformation?.idNumber || ''],
        });
    }
    console.log('11111100000', changeList);
    return changeList;
  };
  const requestData2 = {
    fieldChanges: isChangeList(),
    changeType: '04',
    uploadFlag: false,
    companyCode: companyCode,
    policyNo: policyNumber,
  };
  const ConfrimClick = (values: PaymentArrangementFormData) => {
    console.log('ConfrimClick', values);
    navigate('/LifechgepaymentOtpVerificationPage', {
      replace: true,
      state: {
        requestData2: requestData2,
        policyNumber: policyNumber,
      },
    });
  };
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [Message, setMessage] = useState<string>('');

  const {
    data: validateMessage,
    error: validateError,
    shouldFetch: shouldValidateFetch,
  } = useRequestValidate('request-validate' + randoms, token || '', requestData2);
  useEffect(() => {
    if (validateMessage?.success) {
      shouldValidateFetch(false);
      setaftersub(true);
    }
  }, [validateMessage, shouldValidateFetch, errorMessage]);
  useEffect(() => {
    if (validateError && validateError?.code) {
      shouldValidateFetch(false);
      console.log('validateError', validateError.code);
      setErrorMessage(validateError.code);
      setMessage(validateError.message);
    }
  }, [validateError, i18n, shouldValidateFetch]);
  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [i18n.language, form]);
  return (
    <EnquiryPageContainer className="ChagepaPage">
      <div style={{ width: '100%' }}>
        <GreetingSection pageName={t('life.MakeRequest.payment.paymenttittle')} showicon={false} />
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', top: '-18px', position: 'relative' }}>
          {policyTypesObject.length > 0 && (
            <Select
              onChange={PnChange}
              placeholder={t('life.MakeRequest.payment.Pleaseselect')}
              className="policySelect"
              popupClassName="slectop"
              defaultValue={policyNo ? policyNo : undefined}
              value={policyNumber ? policyNumber : undefined}
              style={{
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                padding: '4px 0',
                width: '640px',
              }}
              // optionLabelProp={{}}
            >
              {policyTypesObject &&
                policyTypesObject.map((item) => (
                  <Select.Option key={item.value} value={item.value} label2={item.label2} title={item.label2}>
                    <div style={{ display: 'grid', gridTemplateColumns: '15px 1fr', alignItems: 'center', gap: '8px' }}>
                      {item.inactiveAutoPayAccount == 'Y' && (
                        <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#C21B17' }} />
                      )}
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          color: item.inactiveAutoPayAccount == 'Y' ? '#C21B17' : '#000000d9',
                        }}
                      >
                        <span>{item.label}</span>
                        <span>{item.label2}</span>
                      </div>
                    </div>
                  </Select.Option>
                ))}
            </Select>
          )}
          {policyTypesObject.length <= 0 && (
            <Select
              onChange={PnChange}
              placeholder={t('life.MakeRequest.payment.Pleaseselect')}
              className="policySelectD"
              popupClassName="slectop"
              defaultValue={policyNo ? policyNo : undefined}
              value={policyNumber ? policyNumber : undefined}
              disabled
              style={{
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                padding: '4px 0',
                width: '640px',
              }}
            >
              {policyTypesObject &&
                policyTypesObject.map((item) => (
                  <Select.Option key={item.value} value={item.value} label2={item.label2} title={item.label2}>
                    <div style={{ display: 'grid', gridTemplateColumns: '15px 1fr', alignItems: 'center', gap: '8px' }}>
                      {item.inactiveAutoPayAccount == 'Y' && (
                        <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#C21B17' }} />
                      )}
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          color: item.inactiveAutoPayAccount == 'Y' ? '#C21B17' : '#000000d9',
                        }}
                      >
                        <span>{item.label}</span>
                        <span>{item.label2}</span>
                      </div>
                    </div>
                  </Select.Option>
                ))}
            </Select>
          )}
        </div>
      </div>
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} className="EnquiryContent">
        <Row
          justify="center"
          gutter={[16, { xs: 8, sm: 8, lg: 24 }]}
          style={{ background: '#fff' }}
          className={`centerlist`}
        >
          {!aftersub && (
            <Row style={{ display: 'grid' }}>
              <div className="header2">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div
                    style={{
                      fontSize: '33px',
                      fontFamily: 'Roboto400',
                      color: '#6f7072',
                    }}
                  >
                    {t('life.MakeRequest.payment.Paymenttittle')}
                  </div>
                  {!EditCode && !EditDisable && policyNumber != '' && (
                    <button
                      style={{ padding: '10px 0 0 0', background: 'transparent', border: 'none', cursor: 'pointer' }}
                      onClick={Edit}
                    >
                      <img src={edit} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                      <span
                        style={{
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          color: '#C21B17',
                        }}
                      >
                        {t('life.MakeRequest.contact.Edit')}
                      </span>
                    </button>
                  )}
                  {!EditCode && EditDisable && (
                    <button style={{ padding: '10px 0 0 0', background: 'transparent', border: 'none' }} disabled>
                      <img src={editdisabled} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                      <span
                        style={{
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          color: '#B0B2B3',
                        }}
                      >
                        {t('life.MakeRequest.contact.Edit')}
                      </span>
                    </button>
                  )}
                </div>
                {EditDisable && (
                  <div>
                    <div
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto700',
                        color: '#E9673D',
                      }}
                    >
                      {Errmessage}
                    </div>
                  </div>
                )}
                {showInactive && (
                  <div>
                    <div
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto700',
                        color: '#E9673D',
                      }}
                    >
                      {t('life.MakeRequest.payment.inactiveAutoPayAccount')}
                    </div>
                  </div>
                )}
              </div>

              {!EditCode && (
                <Form
                  // initialValues={initialValues}
                  layout={'vertical'}
                  requiredMark={false}
                  form={form}
                  disabled={true}
                  validateTrigger={'onBlur'}
                  className="form"

                  //   isLoading={isLoading}
                >
                  {startLoading && <Spinner />}
                  {policyNumber == '' && (
                    <PaymenttactCardno
                      downloadServiceFormEn={downUrl?.paymentDownloadServiceFormEn}
                      downloadServiceFormTc={downUrl?.paymentDownloadServiceFormTc}
                      policyTypesObject={policyTypesObject}
                    />
                  )}
                  {policyNumber != '' && (
                    <PaymentInfomationCard
                      downloadServiceFormEn={downUrl?.paymentDownloadServiceFormEn}
                      downloadServiceFormTc={downUrl?.paymentDownloadServiceFormTc}
                    />
                  )}
                </Form>
              )}
              {EditCode && (
                <Form
                  // initialValues={initialValues}
                  layout={'vertical'}
                  requiredMark={false}
                  form={form}
                  onFinish={onSubmit}
                  validateTrigger={'submit'}
                  className="form"
                  preserve={true}
                  scrollToFirstError={{ behavior: 'smooth', block: 'center' }}
                  //   isLoading={isLoading}
                >
                  {startLoading && <Spinner />}
                  <ChangePaymentContactCard
                    policyTypesObject={policyTypesObject}
                    errorMessage={errorMessage}
                    companyCode={companyCode}
                    Message={Message}
                    policyNumber={policyNumber}
                    ref={childRef}
                  />
                  <AgreementCard2 setIsAgreed={setIsAgreed} />
                  {errorMessage == 'xapi.policy.no.change.request' && (
                    <Alert
                      message={t('life.MakeRequest.hasnochange')}
                      type="error"
                      closable
                      style={{ marginBottom: 16 }}
                    />
                  )}
                  <div className="confrimbutton">
                    <Button
                      // loading={enquirySubmissionIsLoading || isLoading}
                      disabled={!isAgreed}
                      onClick={() => form.submit()}
                      type="primary"
                      className="subbutton"
                      style={{ cursor: 'pointer' }}
                    >
                      {t('life.enquiry.submit')}
                    </Button>
                    <Button
                      // loading={enquirySubmissionIsLoading || isLoading}
                      onClick={() => window.location.reload()}
                      className="cancel"
                      style={{ cursor: 'pointer' }}
                    >
                      {t('life.enquiry.Cancel')}
                    </Button>
                  </div>
                </Form>
              )}
            </Row>
          )}
          {aftersub && (
            <Row style={{ display: 'grid' }}>
              <div className="header2">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div
                    style={{
                      fontSize: '33px',
                      fontFamily: 'Roboto400',
                      color: '#6f7072',
                    }}
                  >
                    {t('life.MakeRequest.ConfirmChanges')}
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: '17px',
                      fontFamily: 'Roboto700',
                      color: '#E9673D',
                    }}
                  >
                    {t('life.MakeRequest.ConfirmText')}
                  </div>
                </div>
              </div>
              <Form
                // initialValues={initialValues}
                layout={'vertical'}
                requiredMark={false}
                form={form2}
                className="form"
                onFinish={ConfrimClick}
                //   isLoading={isLoading}
              >
                {startLoading && <Spinner />}
                <PaymentConfrimCard paymentMethodEn={form.getFieldValue('paymentModeEn')} />
                <div className="confrimbutton">
                  <Button
                    onClick={() => form2.submit()}
                    type="primary"
                    className="subbutton"
                    style={{ cursor: 'pointer' }}
                  >
                    {t('life.MakeRequest.contact.Confirm')}
                  </Button>
                  <Button onClick={() => window.location.reload()} className="cancel" style={{ cursor: 'pointer' }}>
                    {t('life.MakeRequest.contact.Back')}
                  </Button>
                </div>
              </Form>
            </Row>
          )}
        </Row>
      </Row>
    </EnquiryPageContainer>
  );
}

export default ChangePaymentArrangement;
